import React from 'react';
import { SkeletonLoader } from '../../../common/sharedStyledComponents/SkeletonLoader';

export const SelfAssessmentSelectDepartmentSkeleton = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '88px',
        marginLeft: '16px',
        marginRight: '16px',
      }}
    >
      <SkeletonLoader height="24px" />
      <SkeletonLoader height="38px" />
      <SkeletonLoader height="199px" />
      <SkeletonLoader height="199px" />
      <SkeletonLoader height="48px" />
      <SkeletonLoader height="48px" />
      <SkeletonLoader height="48px" />
    </div>
  );
};
